exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wd-container{padding-top:20px}span{display:block}.tiny-form select{margin:0}.tiny-form{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.tiny-form label{padding:3px}.display-field span{display:block;color:#000;font-size:110%}.display-field label{display:block;margin-top:10px;color:#6e6e6e;font-size:80%;margin-bottom:0}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/client/profile/profile.component.css
// module id = 449
// module chunks = 1